import {PreparedRouteType} from "@Route/types/PreparedRoute.type";
import useIsDebugUser from "@Features/debug/hooks/useIsDebugUser";

export default function useShowApiFullIntegrationRouteDebugPopover(route: PreparedRouteType) {
    const isDebugUser = useIsDebugUser()

    return isDebugUser && route?.status?.jsonEncodedApiFullIntegrationData
}